import { render, staticRenderFns } from "./feedback.vue?vue&type=template&id=e98766b2&scoped=true&"
import script from "./feedback.vue?vue&type=script&lang=js&"
export * from "./feedback.vue?vue&type=script&lang=js&"
import style0 from "./feedback.vue?vue&type=style&index=0&id=e98766b2&prod&scoped=true&lang=css&"
import style1 from "./feedback.vue?vue&type=style&index=1&id=e98766b2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e98766b2",
  null
  
)

export default component.exports